import { render } from "./AvatarGroupWithMenu.vue?vue&type=template&id=22cf9a47&ts=true"
import script from "./AvatarGroupWithMenu.vue?vue&type=script&lang=ts"
export * from "./AvatarGroupWithMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__